import m from "../../geodata/es2015/portugalRegionsHigh";
window.am4geodata_portugalRegionsHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/portugalRegionsHigh.js
// module id = null
// module chunks = 